import { Component, OnInit, TemplateRef, Pipe, PipeTransform } from '@angular/core';
import { Database } from './database';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormBuilder, Validators, PatternValidator } from '@angular/forms';
import { DatabaseService } from './database.service';
import { DialogService } from 'ng2-bootstrap-modal';
import { CommondialogComponent } from '../../Shared/commondialog/commondialog.component';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { toBase64String } from '@angular/compiler/src/output/source_map';
import { Observable } from 'rxjs';
import { getimagepipe } from './image.pipe';
import { LocalService } from '../../local.service';

@Component({
  selector: 'app-database',
  templateUrl: './database.component.html',
  styleUrls: ['./database.component.css'],
  providers: [getimagepipe]
})

export class DatabaseComponent implements OnInit {
  sendMenuId: number;
  sendPageName: string = 'Database';
  //action rights
  _menuId: any;
  _actionRights: any;
  submitShow: boolean;
  readOnly: boolean; add: boolean; edit: boolean; delete: boolean;

  databaseForm: FormGroup;
  databases: Database[]; database: Database;
  deleteResult: boolean
  postresult: boolean
  putDResult: boolean
  databaseModalRef: BsModalRef;
  operation: string;
  userid: number;
  databaseid: number;
  submitted = false;
  active: number;
  unamePattern: string;
  confmsg: string;
  p: number = 1; searchText: string;
  itemsPerPage: number = 10;
  base64data: any;
  config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    class: 'modal-dialog-centered',
    ignoreBackdropClick: true,

  }
  mysrc: any;
  imagepath: any;
  formData: FormData;
  fileData: File = null;
  key: string = 'database'; //set default
  reverse: boolean = false;

  constructor(
    private getimage: getimagepipe,
    private _sanitizer: DomSanitizer,
    private http: HttpClient,
    private databaseservice: DatabaseService,
    private modalService: BsModalService,
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService, private dialogService: DialogService,
    private localService: LocalService) {
    //code to get relavent menu id      
    if (this.router.getCurrentNavigation().extras.state != undefined) {
      localStorage.setItem('Database_menuid', this.router.getCurrentNavigation().extras.state.menuid);
      localStorage.setItem('Database_action', this.router.getCurrentNavigation().extras.state.action);
      this._menuId = this.router.getCurrentNavigation().extras.state.menuid;
      this.sendMenuId = this._menuId;
      this._actionRights = this.router.getCurrentNavigation().extras.state.action;
    }
    else {
      if (this._menuId == undefined)
        this._menuId = localStorage.getItem('Database_menuid');
      this.sendMenuId = this._menuId;
      if (this._actionRights == undefined)
        this._actionRights = localStorage.getItem('Database_action');
    } 

  }

  ngOnInit() {
    this.databaseForm = this.formBuilder.group({
      databaseid: [''],
      database: ['', [Validators.required]],
      databasedescription: ['', [Validators.required]],
      ImgFile: [''],
      active: ['']
    });
    this.searchText = '';
    this.getAll();
    //for action rights
    this.readOnly = false;
    this.add = false;
    this.edit = false;
    this.delete = false;
    this.submitShow = false;
    this.getActionRightsList();
  }
   
  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }
  
  getAll() {
    this.databaseservice.Get().subscribe(res => {
      this.databases = res;
    }, error => { this.toastr.error('Error while getting data'); });

  }

  get g() { return this.databaseForm.controls; }

  //assigning value from menu rights button
  getActionRightsList() {
    var btnToEnable = JSON.parse(this._actionRights);
    if (btnToEnable.length > 0) {
      btnToEnable.forEach(d => {
        if (d != undefined) {
          if (d == 1)
            this.readOnly = true;
          else if (d == 2) {
            this.readOnly = true;
            this.add = true;
            this.submitShow = true;
          }
          else if (d == 3) {
            this.readOnly = true;
            this.edit = true;
            // this.submitShow = true;
          }
          else if (d == 4) {
            this.readOnly = true;
            this.delete = true;
          }
        }
      });
    }
  }

  clearForm() {
    //for action rights
    if (this.add == true)
      this.submitShow = true;
    else
      this.submitShow = false;
    this.databaseModalRef.hide();
  }

  onFileSelect(fileInput: any) {
    if (fileInput.target.files.length > 0) {
      const file = fileInput.target.files[0];
      this.databaseForm.get('ImgFile').setValue(file);
    }
  }
 
  getimageedit(filename: string): any {
    
    this.databaseservice.GetImage(filename).subscribe(res => {
      if (res.type != 'text/plain') {
        let objectURL = 'data:image/jpeg;base64,' + res.image;
        this.imagepath = this._sanitizer.bypassSecurityTrustUrl(objectURL);
      }

    }, error => { });

  }

  Post(database: Database) {

    this.submitted = true;
    // stop here if form is invalid
    //if (this.databaseForm.invalid) {
    //  console.log(this.g);
    //  console.log(this.databaseForm.errors);
    //}
    if ((database.database.trim() == undefined) || (database.database.trim() == '')) {
      this.toastr.error('Database should not be empty');
      return;
    }
   
    var msg = null;
    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    database.database = database.database.trim();
    database.databasedescription = database.databasedescription.trim();
    if (this.operation == 'add') {


      database.createdby = this.userid;
      database.databaseid = 0;
      database.active = 1;

      const formData = new FormData();
      formData.set('ImgFile', this.databaseForm.get('ImgFile').value);
      for (var key in database) {
        formData.set(key, database[key]);
      }

      msg = "Record Added Successfully";

      //  let header = new Headers({ 'encrypt': 'multipart/form-data' });
      // header.append('Content-Type', 'multipart/form-data');


      //this.http.post<any>('https://localhost:44357/api/DatabaseApi/add', formData).subscribe(res => {
      this.databaseservice.Post(formData).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            if (res.body != 0) {
              this.databaseModalRef.hide();
              this.getAll();
              this.toastr.success('Data added successfully');
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          
          this.toastr.error(error.error);
          this.postresult = false
        }
      )
    }
    else if (this.operation = 'update') {
      this.submitShow = true;
      database.modifiedby = this.userid;
      const formData = new FormData();
      formData.append('ImgFile', this.databaseForm.get('ImgFile').value);
      for (var key in database) {
        formData.append(key, database[key]);
      }

      msg = "Record updated successfully";
      this.databaseservice.Put(formData).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            if (res.body != 0) {
              this.databaseModalRef.hide();
              this.getAll();
              this.toastr.success('Data updated successfully');
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error(error.error);
          this.postresult = false
        })
    }

  }

  ChangeActive(e) {
    if (e.currentTarget.checked) {
      this.databaseForm.value.active = 1;
    } else {
      this.databaseForm.value.active = 0
    }
  }

  OpenConfirmTemplate(database, template: TemplateRef<any>) {
    if (database.active == 0) {
      this.confmsg = "activate";
    }
    else
      this.confmsg = "deactivate";
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Are you sure you want to ' + this.confmsg + ' this record ?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.database = database;

          this.Delete();

        }
        
      });

  }

  Delete() {
    var msg;
    if (this.database.active == 0) {
      this.database.active = 1
      msg = "Record activated successfully"
    }
    else {
      this.database.active = 0;
      msg = "Record deactivated successfully"
    }
    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    this.database.modifiedby = this.userid;
    this.databaseservice.Delete(this.database).subscribe(res => {
      this.toastr.success(msg);
      this.getAll();
    },
      error => { this.deleteResult = false })

  }

  hidePopup() {
    this.databaseModalRef.hide();
  }

  openDatabaseModal(template: TemplateRef<any>, type, database?: Database, ) {
    this.operation = type
    
    if (type == 'update') {
      this.databaseForm.controls['databaseid'].setValue(database.databaseid);
      this.databaseForm.controls['database'].setValue(database.database);
      this.databaseForm.controls['databasedescription'].setValue(database.databasedescription);
      this.databaseForm.controls['active'].setValue(database.active);
      this.imagepath = this.getimageedit(database.databaseiconpath);
      this.database = database;
    }
    if (type == 'add') {
      this.databaseForm.controls['databaseid'].setValue(0);
      this.databaseForm.controls['database'].setValue('');
      this.databaseForm.controls['databasedescription'].setValue('');
      this.databaseForm.controls['active'].setValue(1);
      this.imagepath = this.getimageedit('');
    }
    this.databaseModalRef = this.modalService.show(template, this.config);
    const aa = document.getElementsByClassName('modal-content');
    aa[0].classList.remove("modal-content");


  }

}
